export default __webpack_public_path__ + "static/media/service6.7ac9f526.jpg";